
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import './styles/ui.css';
import Login from './pages/Login';
import Home from './pages/Home';
import AddRide from './pages/Add_Ride';
import CompleteProfile from './pages/CompleteProfile';
import Profile from './pages/Profile';
import MyRides from './pages/MyRides';
import { useState, useEffect } from 'react';
import RefrshHandler from './RefrshHandler';
import TopNav from './components/TopNav';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Set authentication status based on token existence
    setIsAuthenticated(!!localStorage.getItem('token'));
  }, []);

  const PrivateRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  return (
    <div className="App">
      <RefrshHandler setIsAuthenticated={setIsAuthenticated} />
      <TopNav />
      <Routes>
        <Route path='/' element={<Navigate to="/login" />} />
        <Route path='/login' element={<Login />} />
        <Route path='/complete-profile' element={<PrivateRoute><CompleteProfile /></PrivateRoute>} />
        <Route path='/home' element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path='/Add_Ride' element={<PrivateRoute><AddRide /></PrivateRoute>} />
        <Route path='/profile' element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path='/my-rides' element={<PrivateRoute><MyRides /></PrivateRoute>} />
      </Routes>
    </div>
  );
}

export default App;
